import React from "react";
import { HelpCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { useTour } from "@/hooks/useTour";

export const TourHelpButton: React.FC = () => {
	const { t } = useTranslation();
	const tour = useTour();
	return (
		<Button
			variant="ghost"
			size="icon"
			onClick={tour.start}
			title={t("tour.restart")}
			aria-label={t("tour.restart")}
			data-tour="topbar-help"
		>
			<HelpCircle className="h-5 w-5" />
		</Button>
	);
};
